/**
 * Matter Role Options
 * Fixed options for matter roles in tenant access grants.
 */

export const MATTER_ROLE_OPTIONS = [
  { value: '', label: '(None)' },
  { value: 'lead_counsel', label: 'Lead Counsel' },
  { value: 'counsel', label: 'Counsel' },
  { value: 'associate', label: 'Associate' },
  { value: 'paralegal', label: 'Paralegal' },
  { value: 'expert', label: 'Expert' },
  { value: 'consultant', label: 'Consultant' },
];
